import React, { useEffect, useState } from 'react';
import { REDIRECT_CONFIG, logPlatformDetection } from './redirectConfig';

const RedirectPage: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isRedirecting, setIsRedirecting] = useState(true);
  const [detectedPlatform, setDetectedPlatform] = useState<string>('');

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    
    // Add a small delay to show the loading message
    setTimeout(() => {
      if (/android/i.test(userAgent)) {
        setDetectedPlatform('Android');
        logPlatformDetection('Android', userAgent);
        window.location.href = REDIRECT_CONFIG.ANDROID_URL;
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
        setDetectedPlatform('iOS');
        logPlatformDetection('iOS', userAgent);
        window.location.href = REDIRECT_CONFIG.IOS_URL;
      } else {
        setDetectedPlatform('Desktop');
        logPlatformDetection('Desktop', userAgent);
        window.location.href = REDIRECT_CONFIG.FALLBACK_URL;
      }
    }, REDIRECT_CONFIG.REDIRECT_DELAY);
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.spinner}></div>
        <h2 style={styles.title}>Redirecting...</h2>
        <p style={styles.message}>
          {detectedPlatform ? 
            `Detected ${detectedPlatform} device. Taking you to the right place...` :
            'Detecting your device platform...'
          }
        </p>
        <p style={styles.fallback}>
          If you're not redirected automatically, 
          <a href="/" style={styles.link}> click here to go to our website</a>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f9fafb',
    fontFamily: "'Inter', sans-serif",
  },
  content: {
    textAlign: 'center' as const,
    padding: '2rem',
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    maxWidth: '400px',
    width: '90%',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #e5e7eb',
    borderTop: '4px solid #3498db',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 1rem auto',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '0.5rem',
  },
  message: {
    color: '#666',
    marginBottom: '1rem',
    fontSize: '1rem',
  },
  fallback: {
    fontSize: '0.875rem',
    color: '#888',
  },
  link: {
    color: '#3498db',
    textDecoration: 'none',
  },
};

// Add CSS animation for spinner
const spinnerCSS = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

// Inject CSS
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = spinnerCSS;
  document.head.appendChild(style);
}

export default RedirectPage;